<template>
  <modal-component
    :is-displayed="true"
    :is-full-screen-modal="false"
    :remove-outside-click="false"
    :title="$t('WorkOrders.MoveSensor')"
    @toggle-modal="$emit('toggle-modal')"
  >
    <div class="px-6">
      <div class="mb-12 mt-6 flex w-full flex-col items-center">
        <h2 class="text-xl font-medium">
          {{ question }}
        </h2>
      </div>
      <div class="grid w-full grid-cols-2 gap-10">
        <the-button
          :text="$t('General.Cancel')"
          variant="outline"
          @execute-method="$emit('toggle-modal')"
        />
        <the-button
          :is-loading="isSubmitLoading"
          :text="$t('WorkOrders.MoveSensor')"
          variant="default"
          @execute-method="moveSensor"
        />
      </div>
    </div>
  </modal-component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ModalComponent from "@/core/Components/Modal.vue";
import TheButton from "@/core/Components/TheButton.vue";
import { useToast } from "vue-toastification";
import WorkOrderService from "../Services/WorkOrderService";
import { ErrorMessageFormatter } from "@/core/Services/GlobalFunctions";

export default defineComponent({
  components: {
    ModalComponent,
    TheButton,
  },
  emits: ["toggle-modal"],
  props: ["mac", "imei", "idType", "workOrderId", "refreshData"],
  data() {
    return {
      identifier: "",
      isSubmitLoading: false,
      toast: useToast(),
      workOrderService: new WorkOrderService(),
    };
  },
  mounted() {
    if (this.idType == "imei") {
      this.identifier = this.imei;
    } else {
      this.identifier = this.mac;
    }
  },
  computed: {
    question() {
      return (this as any).$t("WorkOrders.MoveQuestion", {
        id: this.identifier,
      });
    },
  },
  methods: {
    async moveSensor() {
      this.isSubmitLoading = true;
      try {
        const res = await this.workOrderService.moveSensor(
          this.identifier,
          this.idType,
          this.workOrderId
        );
        if (res != 0) {
          this.toast.success((this as any).$t("WorkOrders.MoveSuccess"));
        } else {
          this.toast.error((this as any).$t("WorkOrders.MoveError"));
        }
      } catch (error) {
        this.toast.error(ErrorMessageFormatter(error));
      } finally {
        this.refreshData();
        this.isSubmitLoading = false;
        this.$emit("toggle-modal");
      }
    },
  },
});
</script>

<style scoped></style>
